import React from "react";
import FormError from "../formError/FormError";
import { IsAllow } from "../../utils/allowHelper/AllowHelper";

const ClientFormIP = ({
  client,
  onChange,
  allow,
  translate,
  form,
  readOnly,
}) => {
  if (!IsAllow(allow, "customer-01")) return null;

  return (
    <div>
      <div className="flex items-center gap-4 mb-2">
        <label className="label">{translate("ip-address")}</label>
        <div
          className={`flex items-center px-2 py-1 rounded ${
            client.verificationIP
              ? "bg-blue-500"
              : "bg-slate-900 dark:bg-slate-300"
          }`}
        >
          <input
            name="verificationIP"
            type="checkbox"
            className={`mr-2 `}
            onChange={onChange}
            checked={!!client.verificationIP}
            disabled={readOnly}
          />
          <span
            className={`text-xs ${
              client.verificationIP
                ? "text-white"
                : "text-white dark:text-gray-900 "
            }`}
          >
            {translate("verify-ip")}
          </span>
        </div>
      </div>
      <input
        type="text"
        name="ipAddress"
        value={client.ipAddress}
        onChange={onChange}
        placeholder="Ejemplo: 192.168.0.1"
        className="input"
        disabled={readOnly}
      />
      <FormError form={form} name="ipAddress" />
      <p className="text-xs text-gray-500 dark:text-gray-400 mt-1">
        {translate("ip-format-example")} (xxx.xxx.xxx.xxx)
      </p>
    </div>
  );
};

export default ClientFormIP;
